import React from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { useAuth } from '../../contexts/AuthContext';

// ProtectedRoute plus role === 'ADMIN'; otherwise redirect to /dashboard (QA-53).
export default function AdminRoute({ children }) {
  const { user } = useAuth();

  return (
    <ProtectedRoute>
      {user?.role === 'ADMIN' ? children : <Navigate to="/dashboard" replace />}
    </ProtectedRoute>
  );
}
